<template>
  <div class="post-loader">
    <content-loader
      :height="450"
      :width="400"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#fae4ec"
    >
      <rect x="0" y="0" rx="4" ry="4" width="200" height="24" />
      <rect x="0" y="42" rx="4" ry="4" width="100" height="16" />
      <rect x="0" y="80" rx="4" ry="4" width="350" height="10" />
      <rect x="0" y="96" rx="4" ry="4" width="380" height="10" />
      <rect x="0" y="128" rx="4" ry="4" width="200" height="10" />
      <rect x="0" y="112" rx="4" ry="4" width="380" height="10" />
      <rect x="0" y="164" rx="4" ry="4" width="400" height="200" />
      <rect x="0" y="380" rx="4" ry="4" width="200" height="16" />
      <rect x="300" y="380" rx="4" ry="4" width="100" height="16" />
      <rect x="0" y="416" rx="50" ry="50" width="30" height="30" />
      <rect x="35" y="416" rx="15" ry="15" width="330" height="30" />
      <rect x="370" y="416" rx="50" ry="50" width="30" height="30" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "PostContentLoader",
  components: {
    ContentLoader
  }
};
</script>

<style scoped>
.post-loader {
  padding: 36px 7.5%;
}
</style>
